/* eslint-disable no-console */

/**
 * Wraps a function. When the wrapped function is called
 * an error is emitted *once*.
 * @function
 * @param {function} func the deprecated function
 * @param {string} [msg="{func.name} is deprecated"]
 * @return {function} wrapped *func*
 * @example
 * import {deprecate} from 'js-utils';
 * function deprecatedFunc() {}
 * export const func = deprecate(deprecatedFunc);
 */
export let deprecate;

if (process.env.NODE_ENV !== 'production') {
	deprecate = (func, msg = `${func.name || 'unknown'} is deprecated`) => {
		let warned = false;

		return function $deprecate(...args) {
			if (!warned) {
				console::(console.warn || console.log)(msg);

				if (typeof console.trace === 'function') {
					console.trace();
				}

				warned = true;
			}

			return this::func(...args);
		};
	};
} else {
	deprecate = func => func;
}
